import React, { Component } from 'react';
import EffectParameterSlider from './EffectParameterSlider.js';
import WetSlider from './WetSlider.js';

class SaturatorEffect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            effect: props.effect,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        this.state.effect = nextProps.effect;
        return true;
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.state.effect.isEnabled();
    }

    render() {
        let compressor = this.state.effect.compressorNode;
        let gainNode = this.state.effect.effectNode;
        let className = this.props.automation !== undefined ?
            'enabled tall-effect effect effect-automation' :
            this.state.effect.isEnabled() ? 'tall-effect effect enabled' :
            'effect disabled';
        return (
            <div>
              {!this.isEnabled() ? '' :
                <div>
                  <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='Drive'
                        selectedParameter={this.props.selectedParameter}
                        sequencerEngine={this.props.sequencerEngine}
                        lfoEnabled={true}
                        parameter={this.state.effect.driveParameter}
                        isParameter={true}
                        onParameterChanged={this.props.onParameterChanged}
                        step={0.01}
                    root={3}
                        max={32}
                        min={0.01}
                        />
                 </div>} 
            </div>
        );
    }
}

export default SaturatorEffect;
